import { __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import PaymentsService from '@/modules/requests/requestsTables/PaymentsService';
var payment = {};

var PaymentModel =
/** @class */
function (_super) {
  __extends(PaymentModel, _super);

  function PaymentModel() {
    var _this = _super.call(this, payment, PaymentsService) || this;

    _this.modelName = 'Pago';
    return _this;
  }

  PaymentModel.prototype.closeWithDojo = function (data, toast) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , PaymentsService.closeWithDojo({
              query: data
            })];

          case 1:
            response = _a.sent();

            if (response.complete) {
              this.handleSuccess(response, response.message, toast);
              return [2
              /*return*/
              , true];
            }

            this.handleError(response, toast);
            return [2
            /*return*/
            , false];
        }
      });
    });
  };

  PaymentModel.prototype.cancelCloseWithDojo = function (data, toast) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , PaymentsService.cancelCloseWithDojo({
              query: data
            })];

          case 1:
            response = _a.sent();

            if (response.complete) {
              this.handleSuccess(response, response.message, toast);
              return [2
              /*return*/
              , true];
            }

            this.handleError(response, toast);
            return [2
            /*return*/
            , false];
        }
      });
    });
  };

  PaymentModel.prototype.closeWithCashmatic = function (data, toast) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , PaymentsService.closeWithCashmatic({
              query: data
            })];

          case 1:
            response = _a.sent();

            if (response.complete) {
              this.handleSuccess(response, response.message, toast);
              return [2
              /*return*/
              , true];
            }

            this.handleError(response, toast);
            return [2
            /*return*/
            , false];
        }
      });
    });
  };

  PaymentModel.prototype.cancelCloseWithCashmatic = function (data, toast) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , PaymentsService.cancelCloseWithCashmatic({
              query: data
            })];

          case 1:
            response = _a.sent();

            if (response.complete) {
              this.handleSuccess(response, response.message, toast);
              return [2
              /*return*/
              , true];
            }

            this.handleError(response, toast);
            return [2
            /*return*/
            , false];
        }
      });
    });
  };

  PaymentModel.prototype.confirmHandSign = function (data, toast) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , PaymentsService.confirmPayment({
              query: data
            })];

          case 1:
            response = _a.sent();

            if (response.complete) {
              this.handleSuccess(response, response.message, toast);
              return [2
              /*return*/
              , true];
            }

            this.handleError(response, toast);
            return [2
            /*return*/
            , false];
        }
      });
    });
  };

  PaymentModel.prototype.confirmPayment = function (data, toast) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , PaymentsService.confirmPayment({
              query: data
            })];

          case 1:
            response = _a.sent();

            if (response.complete) {
              this.handleSuccess(response, response.message, toast);
              return [2
              /*return*/
              , true];
            }

            this.handleError(response, toast);
            return [2
            /*return*/
            , false];
        }
      });
    });
  };

  return PaymentModel;
}(BaseModel);

export default PaymentModel;